import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=f4d5e408&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=f4d5e408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d5e408",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4d5e408')) {
      api.createRecord('f4d5e408', component.options)
    } else {
      api.reload('f4d5e408', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=f4d5e408&scoped=true&", function () {
      api.rerender('f4d5e408', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/topManagement/subjectDynamic/components/addDynamic.vue"
export default component.exports